import {MacOSCursor} from '@remotion/mac-cursors';
import {Video} from '@remotion/media';
import {AbsoluteFill, Easing, interpolate, useCurrentFrame} from 'remotion';

export const ColorCorrectionStudioRecordingComposition = () => {
	const frame = useCurrentFrame();

	return (
		<AbsoluteFill
			name="Canvas Capture"
			durationInFrames={569}
			style={{
				width: 2560,
				height: 1350,
			}}
		>
			<Video
				src="https://remotion.media/studio/effects/color-correction-capture-20261023-105942.mp4"
				durationInFrames={569}
				style={{
					position: 'absolute',
				}}
			/>
			<MacOSCursor
				cursor={interpolate(
					frame,
					[
						7, 20, 22, 34, 35, 55, 106, 112, 241, 243, 245, 248, 483, 486, 489,
						490, 491, 492, 493,
					],
					[
						'auto',
						'ew-resize',
						'default',
						'auto',
						'default',
						'ew-resize',
						'default',
						'ew-resize',
						'default',
						'auto',
						'default',
						'ew-resize',
						'default',
						'auto',
						'default',
						'auto',
						'custom',
						'default',
						'auto',
					],
					{
						easing: Easing.step1,
						extrapolateLeft: 'clamp',
						extrapolateRight: 'clamp',
					},
				)}
				customCursor={
					'url("data:image/svg+xml,%3Csvg%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2064%2064%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cstyle%3E%0A%3Awhere(%3Aroot)%20%7B%0A%20%20--remotion-studio-black%3A%20black%3B%0A%20%20--remotion-studio-white%3A%20white%3B%0A%20%20--remotion-studio-red%3A%20red%3B%0A%20%20--remotion-studio-transparent%3A%20transparent%3B%0A%20%20--remotion-studio-current-color%3A%20currentColor%3B%0A%20%20--remotion-studio-background%3A%20rgb(31%2C36%2C40)%3B%0A%20%20--remotion-studio-background-transparent%3A%20rgba(31%2C36%2C40%2C%200)%3B%0A%20%20--remotion-studio-input-background%3A%20%232f363d%3B%0A%20%20--remotion-studio-tab-hover-background%3A%20%23232629%3B%0A%20%20--remotion-studio-light-color%3A%20%23ddd%3B%0A%20%20--remotion-studio-light-text%3A%20%23A6A7A9%3B%0A%20%20--remotion-studio-ruler-color%3A%20%23808080%3B%0A%20%20--remotion-studio-white-alpha-05%3A%20rgba(255%2C%20255%2C%20255%2C%200.05)%3B%0A%20%20--remotion-studio-white-alpha-06%3A%20rgba(255%2C%20255%2C%20255%2C%200.06)%3B%0A%20%20--remotion-studio-white-alpha-08%3A%20rgba(255%2C%20255%2C%20255%2C%200.08)%3B%0A%20%20--remotion-studio-white-alpha-10%3A%20rgba(255%2C%20255%2C%20255%2C%200.1)%3B%0A%20%20--remotion-studio-white-alpha-12%3A%20rgba(255%2C%20255%2C%20255%2C%200.12)%3B%0A%20%20--remotion-studio-white-alpha-15%3A%20rgba(255%2C%20255%2C%20255%2C%200.15)%3B%0A%20%20--remotion-studio-white-alpha-20%3A%20rgba(255%2C%20255%2C%20255%2C%200.2)%3B%0A%20%20--remotion-studio-white-alpha-25%3A%20rgba(255%2C%20255%2C%20255%2C%200.25)%3B%0A%20%20--remotion-studio-white-alpha-30%3A%20rgba(255%2C%20255%2C%20255%2C%200.3)%3B%0A%20%20--remotion-studio-white-alpha-35%3A%20rgba(255%2C%20255%2C%20255%2C%200.35)%3B%0A%20%20--remotion-studio-white-alpha-40%3A%20rgba(255%2C%20255%2C%20255%2C%200.4)%3B%0A%20%20--remotion-studio-white-alpha-45%3A%20rgba(255%2C%20255%2C%20255%2C%200.45)%3B%0A%20%20--remotion-studio-white-alpha-50%3A%20rgba(255%2C%20255%2C%20255%2C%200.5)%3B%0A%20%20--remotion-studio-white-alpha-60%3A%20rgba(255%2C%20255%2C%20255%2C%200.6)%3B%0A%20%20--remotion-studio-white-alpha-70%3A%20rgba(255%2C%20255%2C%20255%2C%200.7)%3B%0A%20%20--remotion-studio-white-alpha-72%3A%20rgba(255%2C%20255%2C%20255%2C%200.72)%3B%0A%20%20--remotion-studio-white-alpha-80%3A%20rgba(255%2C%20255%2C%20255%2C%200.8)%3B%0A%20%20--remotion-studio-white-alpha-90%3A%20rgba(255%2C%20255%2C%20255%2C%200.9)%3B%0A%20%20--remotion-studio-black-alpha-28%3A%20rgba(0%2C%200%2C%200%2C%200.28)%3B%0A%20%20--remotion-studio-black-alpha-30%3A%20rgba(0%2C%200%2C%200%2C%200.3)%3B%0A%20%20--remotion-studio-black-alpha-40%3A%20rgba(0%2C%200%2C%200%2C%200.4)%3B%0A%20%20--remotion-studio-black-alpha-50%3A%20rgba(0%2C%200%2C%200%2C%200.5)%3B%0A%20%20--remotion-studio-black-alpha-60%3A%20rgba(0%2C%200%2C%200%2C%200.6)%3B%0A%20%20--remotion-studio-black-alpha-80%3A%20rgba(0%2C%200%2C%200%2C%200.8)%3B%0A%20%20--remotion-studio-black-alpha-85%3A%20rgba(0%2C%200%2C%200%2C%200.85)%3B%0A%20%20--remotion-studio-black-alpha-90%3A%20rgba(0%2C%200%2C%200%2C%200.9)%3B%0A%20%20--remotion-studio-fail-color%3A%20%23ff3232%3B%0A%20%20--remotion-studio-warning-color%3A%20%23f1c40f%3B%0A%20%20--remotion-studio-blue%3A%20%230b84f3%3B%0A%20%20--remotion-studio-blue-hovered%3A%20%234da3f7%3B%0A%20%20--remotion-studio-blue-disabled%3A%20%23284f73%3B%0A%20%20--remotion-studio-unselected-guide%3A%20%237e1219%3B%0A%20%20--remotion-studio-selected-guide%3A%20%23d22d3a%3B%0A%20%20--remotion-studio-line-color%3A%20%23363A3E%3B%0A%20%20--remotion-studio-timeline-track-separator%3A%20%2313161B%3B%0A%20%20--remotion-studio-light-gray%3A%20%23ccc%3B%0A%20%20--remotion-studio-keyboard-shortcut-key-color%3A%20%23eee%3B%0A%20%20--remotion-studio-notification-background%3A%20%23111111%3B%0A%20%20--remotion-studio-render-status-background%3A%20%23222%3B%0A%20%20--remotion-studio-error-code-frame-background%3A%20%23070707%3B%0A%20%20--remotion-studio-error-code-frame-line-background%3A%20%23121212%3B%0A%20%20--remotion-studio-error-link-color%3A%20%2358a6ff%3B%0A%20%20--remotion-studio-info-blue%3A%20%2360a5fa%3B%0A%20%20--remotion-studio-server-disconnected-background%3A%20%23e74c3c%3B%0A%20%20--remotion-studio-timeline-background-color%3A%20%2315181B%3B%0A%20%20--remotion-studio-timeline-negative-start-background-color%3A%20%232C2F32%3B%0A%20%20--remotion-studio-timeline-negative-start-border-color%3A%20%23414446%3B%0A%20%20--remotion-studio-timeline-selected-background-color%3A%20%233B3F42%3B%0A%20%20--remotion-studio-timeline-selected-label-background-color%3A%20%23B0B0B0%3B%0A%20%20--remotion-studio-timeline-blue%3A%20%230b84ff%3B%0A%20%20--remotion-studio-timeline-playhead-color%3A%20%23f02c00%3B%0A%20%20--remotion-studio-timeline-drop-blue-alpha-12%3A%20rgba(0%2C%20155%2C%20255%2C%200.12)%3B%0A%20%20--remotion-studio-timeline-drop-blue-alpha-16%3A%20rgba(0%2C%20155%2C%20255%2C%200.16)%3B%0A%20%20--remotion-studio-timeline-drop-blue-alpha-75%3A%20rgba(0%2C%20155%2C%20255%2C%200.75)%3B%0A%20%20--remotion-studio-timeline-marquee-blue-alpha-16%3A%20rgba(70%2C%20130%2C%20255%2C%200.16)%3B%0A%20%20--remotion-studio-timeline-marquee-blue-alpha-75%3A%20rgba(70%2C%20130%2C%20255%2C%200.75)%3B%0A%20%20--remotion-studio-easing-selected-background%3A%20rgba(11%2C%20132%2C%20243%2C%200.18)%3B%0A%20%20--remotion-studio-info-blue-background%3A%20rgba(59%2C%20130%2C%20246%2C%200.15)%3B%0A%20%20--remotion-studio-color-picker-checker-background-color%3A%20var(--remotion-studio-background)%3B%0A%20%20--remotion-studio-color-picker-hue-gradient%3A%20linear-gradient(to%20right%2C%20%23f00%200%25%2C%20%23ff0%2017%25%2C%20%230f0%2033%25%2C%20%230ff%2050%25%2C%20%2300f%2067%25%2C%20%23f0f%2083%25%2C%20%23f00%20100%25)%3B%0A%20%20--remotion-studio-timeline-audio-gradient%3A%20linear-gradient(rgb(16%20171%2058)%2C%20rgb(43%20165%2063)%2060%25)%3B%0A%20%20--remotion-studio-timeline-video-gradient%3A%20linear-gradient(to%20top%2C%20%238e44ad%2C%20%239b59b6)%3B%0A%20%20--remotion-studio-timeline-captions-gradient%3A%20linear-gradient(to%20top%2C%20%23b96516%2C%20%23cc7828)%3B%0A%20%20--remotion-studio-focus-color%3A%20%23555%3B%0A%20%20--remotion-studio-color-picker-checker-color%3A%20var(--remotion-studio-white-alpha-15)%3B%0A%20%20--remotion-studio-info-blue-border-color%3A%20rgba(59%2C%20130%2C%20246%2C%200.4)%3B%0A%20%20--remotion-studio-black-alpha-22%3A%20rgba(0%2C%200%2C%200%2C%200.22)%3B%0A%20%20--remotion-studio-font-family-error-color%3A%20%23ff8a8a%3B%0A%20%20--remotion-studio-selected-outline-snap-color%3A%20%23ff00ff%3B%0A%20%20--remotion-studio-prism-text-color%3A%20%23d4d4d4%3B%0A%20%20--remotion-studio-prism-selection-background%3A%20%23264f78%3B%0A%20%20--remotion-studio-prism-background%3A%20%231e1e1e%3B%0A%20%20--remotion-studio-prism-inline-color%3A%20%23db4c69%3B%0A%20%20--remotion-studio-prism-keyword-color%3A%20%23569cd6%3B%0A%20%20--remotion-studio-prism-variable-color%3A%20%239cdcfe%3B%0A%20%20--remotion-studio-prism-comment-color%3A%20%236a9955%3B%0A%20%20--remotion-studio-prism-number-color%3A%20%23b5cea8%3B%0A%20%20--remotion-studio-prism-string-color%3A%20%23ce9178%3B%0A%20%20--remotion-studio-prism-control-flow-color%3A%20%23c586c0%3B%0A%20%20--remotion-studio-prism-function-color%3A%20%23dcdcaa%3B%0A%20%20--remotion-studio-prism-regex-color%3A%20%23d16969%3B%0A%20%20--remotion-studio-prism-class-name-color%3A%20%234ec9b0%3B%0A%20%20--remotion-studio-prism-selector-color%3A%20%23d7ba7d%3B%0A%20%20--remotion-studio-prism-line-highlight-background%3A%20%23f7ebc6%3B%0A%20%20--remotion-studio-prism-line-highlight-border-color%3A%20%23f7d87c%3B%0A%7D%0A%3C%2Fstyle%3E%3Cg%20transform%3D%22rotate(90%2032%2032)%22%3E%3Cg%20transform%3D%22scale(0.876712329)%22%20filter%3D%22url(%23filter0_d_1_14)%22%3E%3Cpath%20d%3D%22M10.9111%2017.7687C10.3413%2018.3701%2010.367%2019.3195%2010.9684%2019.8893L20.7687%2029.1738C21.3701%2029.7436%2022.3195%2029.7179%2022.8893%2029.1165C23.459%2028.5151%2023.4334%2027.5657%2022.832%2026.996L14.1206%2018.7431L22.3735%2010.0316C22.9432%209.43022%2022.9176%208.48082%2022.3162%207.91107C21.7148%207.34133%2020.7654%207.36699%2020.1956%207.96839L10.9111%2017.7687ZM49.3923%2058.3118C49.9509%2058.9235%2050.8996%2058.9667%2051.5114%2058.4081L61.481%2049.3055C62.0927%2048.7469%2062.1359%2047.7981%2061.5773%2047.1863C61.0187%2046.5745%2060.0699%2046.5314%2059.4581%2047.09L50.5963%2055.1812L42.5051%2046.3194C41.9465%2045.7076%2040.9977%2045.6645%2040.386%2046.2231C39.7742%2046.7817%2039.7311%2047.7304%2040.2896%2048.3422L49.3923%2058.3118ZM12.6747%2018.7431L13%2019.8893C22.1283%2019.6426%2030.7584%2021.4283%2037.8564%2026.6927C44.8518%2031.8809%2049.734%2039.8538%2049%2056H50.5963H51.5114C52.2774%2039.1461%2047.6482%2030.2198%2039.6436%2024.2831C31.7416%2018.4224%2022.3717%2017.2467%2013%2017.5L12.6747%2018.7431Z%22%20fill%3D%22var(--remotion-studio-black)%22%2F%3E%3Cpath%20d%3D%22M19.1064%206.93652C20.2459%205.73379%2022.1448%205.68278%2023.3477%206.82227C24.5505%207.96181%2024.6022%209.86076%2023.4629%2011.0635L18.7373%2016.0508C26.3487%2016.4239%2033.9128%2018.1651%2040.5371%2023.0781C44.7339%2026.1907%2048.0794%2030.1189%2050.2568%2035.4834C51.9666%2039.6958%2052.9327%2044.7395%2053.0742%2050.8867L58.4463%2045.9824C59.6697%2044.8654%2061.5673%2044.9514%2062.6846%2046.1748C63.8018%2047.3985%2063.7155%2049.296%2062.4922%2050.4131L52.5225%2059.5156C51.337%2060.5979%2049.5196%2060.5507%2048.3916%2059.4346L48.2842%2059.3232L39.1816%2049.3535C38.0648%2048.1301%2038.1507%2046.2324%2039.374%2045.1152C40.5975%2043.9979%2042.4961%2044.0841%2043.6133%2045.3076L47.4756%2049.5381C47.1908%2044.7613%2046.2876%2040.9448%2044.9482%2037.8291C43.0666%2033.4521%2040.2851%2030.3614%2036.9629%2027.8975C31.8259%2024.0875%2025.8071%2022.1663%2019.2891%2021.5732L23.8633%2025.9072C25.0662%2027.0468%2025.1178%2028.9457%2023.9785%2030.1484C22.8746%2031.3135%2021.0576%2031.3982%2019.8516%2030.3662L19.7373%2030.2627L9.93652%2020.9785C8.73384%2019.839%208.6828%2017.9401%209.82227%2016.7373L19.1064%206.93652Z%22%20stroke%3D%22var(--remotion-studio-white)%22%20stroke-width%3D%223%22%2F%3E%3C%2Fg%3E%3C%2Fg%3E%3Cdefs%3E%3Cfilter%20id%3D%22filter0_d_1_14%22%20x%3D%220%22%20y%3D%220%22%20width%3D%2272.4696%22%20height%3D%2272.3004%22%20filterUnits%3D%22userSpaceOnUse%22%20color-interpolation-filters%3D%22sRGB%22%3E%3CfeFlood%20flood-opacity%3D%220%22%20result%3D%22BackgroundImageFix%22%2F%3E%3CfeColorMatrix%20in%3D%22SourceAlpha%22%20type%3D%22matrix%22%20values%3D%220%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%20127%200%22%20result%3D%22hardAlpha%22%2F%3E%3CfeOffset%20dy%3D%223%22%2F%3E%3CfeGaussianBlur%20stdDeviation%3D%223.75%22%2F%3E%3CfeComposite%20in2%3D%22hardAlpha%22%20operator%3D%22out%22%2F%3E%3CfeColorMatrix%20type%3D%22matrix%22%20values%3D%220%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200.25%200%22%2F%3E%3CfeBlend%20mode%3D%22normal%22%20in2%3D%22BackgroundImageFix%22%20result%3D%22effect1_dropShadow_1_14%22%2F%3E%3CfeBlend%20mode%3D%22normal%22%20in%3D%22SourceGraphic%22%20in2%3D%22effect1_dropShadow_1_14%22%20result%3D%22shape%22%2F%3E%3C%2Ffilter%3E%3C%2Fdefs%3E%3C%2Fsvg%3E") 12 12, alias'
				}
				style={{
					position: 'absolute',
					left: 0,
					top: 0,
					scale: interpolate(
						frame,
						[0, 76, 224, 261, 471, 525, 531],
						[
							2.341725564742623, 2.107553008268361, 2.341725564742623,
							2.107553008268361, 2.341725564742623, 2.107553008268361,
							2.341725564742623,
						],
						{
							easing: Easing.step1,
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					),
					translate: interpolate(
						frame,
						[
							7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23,
							24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39,
							40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55,
							56, 57, 58, 59, 60, 61, 97, 98, 99, 100, 101, 102, 103, 104, 105,
							106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118,
							119, 120, 121, 122, 123, 124, 125, 126, 127, 128, 129, 130, 131,
							132, 133, 134, 135, 136, 137, 139, 140, 143, 144, 145, 146, 147,
							148, 149, 150, 152, 153, 157, 158, 176, 177, 178, 179, 180, 181,
							182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193, 194,
							195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207,
							208, 209, 210, 211, 212, 213, 214, 215, 217, 218, 240, 241, 242,
							243, 244, 245, 246, 247, 248, 249, 250, 251, 252, 253, 254, 255,
							257, 258, 281, 282, 283, 284, 285, 286, 287, 288, 289, 290, 291,
							292, 294, 295, 297, 298, 299, 300, 301, 302, 303, 304, 305, 306,
							307, 308, 309, 310, 311, 312, 313, 314, 315, 316, 317, 318, 319,
							320, 321, 322, 323, 324, 325, 326, 327, 328, 329, 330, 331, 332,
							333, 334, 335, 336, 337, 338, 339, 340, 341, 342, 343, 344, 345,
							346, 347, 348, 349, 350, 351, 352, 353, 354, 364, 365, 366, 367,
							368, 369, 370, 371, 372, 373, 374, 375, 376, 377, 378, 379, 380,
							381, 382, 383, 384, 385, 386, 387, 388, 389, 390, 391, 392, 393,
							394, 395, 396, 397, 398, 399, 400, 401, 402, 403, 404, 405, 406,
							407, 408, 409, 410, 411, 412, 413, 414, 415, 416, 417, 418, 419,
							420, 421, 422, 423, 424, 425, 426, 427, 428, 429, 430, 431, 432,
							433, 434, 435, 436, 437, 438, 439, 440, 441, 442, 443, 444, 445,
							446, 447, 448, 449, 450, 451, 452, 453, 454, 455, 456, 457, 461,
							462, 482, 483, 484, 485, 486, 487, 488, 489, 490, 491, 492, 493,
							494, 495, 496, 497, 498, 499, 500, 501, 502, 503, 504, 505, 506,
							507, 508, 509, 510, 511, 512, 513, 514, 515, 516, 517, 518, 519,
							520, 521, 522, 523, 524,
						],
						[
							'1275.023833174922px 1540.7913900422352px',
							'1314.9612308923683px 1497.9085406378858px',
							'1361.2834897199334px 1459.489605591327px',
							'1486.8493757637693px 1361.4481422987044px',
							'1560.4765205708527px 1298.5325624772208px',
							'1757.2546469331314px 1139.6611186942137px',
							'1812.3766713594557px 1099.5590683979963px',
							'1867.4986957857802px 1059.4570181017787px',
							'1867.4986957857802px 1059.4570181017787px',
							'2084.675447184684px 851.2172427839436px',
							'2132.223452987544px 783.8468959701568px',
							'2163.3793798372053px 732.0087757537643px',
							'2189.5408451308144px 679.6675504355718px',
							'2215.7023104244236px 633.8575440752943px',
							'2242.2388177030107px 586.9681485875182px',
							'2260.6616117943845px 560.4224939434436px',
							'2285.4692669958768px 520.7595171906154px',
							'2298.915894262172px 498.3118822848404px',
							'2310.121416984085px 475.8642473790654px',
							'2318.7473826385863px 457.0206744752771px',
							'2322.8911392043224px 438.17710157148883px',
							'2325.1322437487047px 419.33352866770053px',
							'2325.1322437487047px 407.0120273563399px',
							'2325.1322437487047px 394.6905260449793px',
							'2325.1322437487047px 382.3690247336187px',
							'2323.220444361864px 370.0475234222581px',
							'2314.365794570181px 359.6286741322509px',
							'2305.511144778498px 349.2098248422437px',
							'2298.3396102364736px 343.60248979854356px',
							'2293.4000328733446px 339.89780677619683px',
							'2291.6071492378387px 338.10492314069074px',
							'2289.8142656023324px 337.20848132293776px',
							'2284.874688239204px 337.20848132293776px',
							'2281.508457739886px 337.20848132293776px',
							'2278.1422272405684px 337.20848132293776px',
							'2274.775996741251px 337.20848132293776px',
							'2272.983113105745px 337.20848132293776px',
							'2268.7204407886743px 337.20848132293776px',
							'2266.9275571531684px 337.20848132293776px',
							'2265.134673517662px 337.20848132293776px',
							'2264.393736913193px 337.20848132293776px',
							'2262.600853277687px 336.3120395051847px',
							'2259.234622778369px 336.3120395051847px',
							'2254.2950454152406px 335.07714516440245px',
							'2252.5021617797343px 335.07714516440245px',
							'2249.2914364937005px 334.3362085599331px',
							'2247.498552858194px 334.3362085599331px',
							'2245.7056692226884px 333.4397667421801px',
							'2243.912785587182px 332.54332492442705px',
							'2243.016343769429px 332.54332492442705px',
							'2241.2234601339233px 331.646883106674px',
							'2240.482523529454px 331.646883106674px',
							'2239.8330605798574px 331.646883106674px',
							'2239.8330605798574px 331.646883106674px',
							'2239.8330605798574px 330.90594650220464px',
							'2239.8330605798574px 330.90594650220464px',
							'2240.1074815444754px 330.90594650220464px',
							'2240.1074815444754px 330.90594650220464px',
							'2241.5802073879267px 330.90594650220464px',
							'2242.357733454345px 330.90594650220464px',
							'2243.071227962353px 330.90594650220464px',
							'2243.071227962353px 330.90594650220464px',
							'2244.3244170341095px 330.90594650220464px',
							'2244.3244170341095px 330.90594650220464px',
							'2245.9069112634083px 330.90594650220464px',
							'2247.562584416605px 330.90594650220464px',
							'2248.413289406922px 330.90594650220464px',
							'2249.309731224675px 330.90594650220464px',
							'2249.309731224675px 330.90594650220464px',
							'2251.001993839821px 330.90594650220464px',
							'2252.6210775310687px 330.90594650220464px',
							'2253.426045693949px 330.90594650220464px',
							'2255.676297603819px 330.90594650220464px',
							'2255.676297603819px 330.90594650220464px',
							'2256.4904131321864px 330.90594650220464px',
							'2258.0363178995362px 330.90594650220464px',
							'2259.682843687246px 330.90594650220464px',
							'2260.54269604305px 330.90594650220464px',
							'2263.1039583794873px 330.90594650220464px',
							'2266.525073071728px 330.90594650220464px',
							'2270.074250880791px 330.90594650220464px',
							'2270.961545333057px 330.90594650220464px',
							'2272.7361342375884px 330.90594650220464px',
							'2273.477070842058px 330.90594650220464px',
							'2274.1265337916543px 330.90594650220464px',
							'2274.8491756651492px 330.90594650220464px',
							'2276.4499646254226px 330.90594650220464px',
							'2278.2702903573904px 330.90594650220464px',
							'2280.1180581858202px 330.90594650220464px',
							'2280.9962052725987px 330.90594650220464px',
							'2282.7524994461555px 330.90594650220464px',
							'2284.545383081662px 330.90594650220464px',
							'2286.319971986193px 330.90594650220464px',
							'2287.9482030429285px 330.90594650220464px',
							'2287.9482030429285px 330.90594650220464px',
							'2288.6799922819105px 330.90594650220464px',
							'2288.6799922819105px 330.90594650220464px',
							'2289.4117815208924px 330.90594650220464px',
							'2289.4117815208924px 330.90594650220464px',
							'2290.015507643053px 330.90594650220464px',
							'2290.015507643053px 330.90594650220464px',
							'2291.2321072528603px 330.90594650220464px',
							'2291.2321072528603px 330.90594650220464px',
							'2291.991338588304px 330.90594650220464px',
							'2292.8054541166716px 330.90594650220464px',
							'2293.5555380866285px 330.90594650220464px',
							'2293.5555380866285px 330.90594650220464px',
							'2294.2507378636615px 330.90594650220464px',
							'2294.2507378636615px 330.90594650220464px',
							'2294.863611351309px 330.90594650220464px',
							'2294.863611351309px 330.90594650220464px',
							'2294.872758716796px 330.90594650220464px',
							'2294.872758716796px 330.90594650220464px',
							'2293.573832817603px 330.90594650220464px',
							'2291.9090122989187px 330.90594650220464px',
							'2291.9090122989187px 330.90594650220464px',
							'2290.2076023182854px 330.90594650220464px',
							'2289.366044693456px 330.90594650220464px',
							'2287.5914557889246px 330.90594650220464px',
							'2285.7802774224438px 330.90594650220464px',
							'2283.987393786938px 330.90594650220464px',
							'2282.56955213641px 330.90594650220464px',
							'2280.8041105973657px 330.90594650220464px',
							'2278.947195403449px 330.90594650220464px',
							'2277.090280209532px 330.90594650220464px',
							'2273.8246707305743px 330.90594650220464px',
							'2271.8031029578865px 330.90594650220464px',
							'2270.870071678184px 330.90594650220464px',
							'2269.10463013914px 330.90594650220464px',
							'2267.3666306965574px 330.90594650220464px',
							'2267.3666306965574px 330.90594650220464px',
							'2265.8024311982335px 330.90594650220464px',
							'2265.0523472282766px 330.90594650220464px',
							'2264.3845895477057px 330.90594650220464px',
							'2263.6436529432362px 330.90594650220464px',
							'2263.6436529432362px 330.90594650220464px',
							'2262.9210110697413px 330.90594650220464px',
							'2262.2166639272214px 330.90594650220464px',
							'2262.2166639272214px 330.90594650220464px',
							'2261.5306115156754px 330.90594650220464px',
							'2261.5306115156754px 330.90594650220464px',
							'2260.8720012005915px 330.90594650220464px',
							'2260.8720012005915px 330.90594650220464px',
							'2260.2408329819696px 330.90594650220464px',
							'2260.2408329819696px 330.90594650220464px',
							'2259.6096647633476px 330.90594650220464px',
							'2259.6096647633476px 330.90594650220464px',
							'2258.9419070827767px 330.90594650220464px',
							'2258.9419070827767px 330.90594650220464px',
							'2258.2741494022052px 330.90594650220464px',
							'2258.2741494022052px 330.90594650220464px',
							'2257.6521285490708px 330.90594650220464px',
							'2257.6521285490708px 330.90594650220464px',
							'2257.6521285490708px 332.04936718811416px',
							'2257.6521285490708px 341.4345641780592px',
							'2257.6521285490708px 348.5878039891089px',
							'2257.6521285490708px 349.47509844137466px',
							'2257.6521285490708px 352.82303420971766px',
							'2257.6521285490708px 354.5976231142492px',
							'2256.7556867313174px 356.3722120187807px',
							'2256.7556867313174px 358.1468009233122px',
							'2255.8592449135645px 359.9213898278437px',
							'2255.8592449135645px 363.2693255961867px',
							'2254.9628030958115px 365.931208952984px',
							'2254.9628030958115px 367.7057978575155px',
							'2254.9628030958115px 369.48038676204703px',
							'2254.9628030958115px 369.48038676204703px',
							'2254.313340146215px 370.12070234615635px',
							'2254.313340146215px 370.12070234615635px',
							'2253.7004666585676px 370.12070234615635px',
							'2253.7004666585676px 370.12070234615635px',
							'2253.4168983284617px 370.12070234615635px',
							'2251.9716145814723px 370.12070234615635px',
							'2250.1512888495045px 370.12070234615635px',
							'2246.821647812136px 370.12070234615635px',
							'2245.815437608536px 370.12070234615635px',
							'2242.37602818532px 370.55977588954556px',
							'2237.308387705369px 371.8769965197133px',
							'2234.7288306379573px 372.31607006310253px',
							'2234.01533612995px 372.7551436064918px',
							'2232.8078838856295px 373.10274349500827px',
							'2232.36881034224px 373.48693284547386px',
							'2232.36881034224px 373.48693284547386px',
							'2231.545547448385px 373.5784065003466px',
							'2231.545547448385px 373.5784065003466px',
							'2230.8229055748907px 373.9351537543504px',
							'2226.8803910498746px 374.4931430490742px',
							'2226.1851912728416px 374.8498903030779px',
							'2222.114613631004px 376.35005824299117px',
							'2218.693498938763px 377.22820532976965px',
							'2217.2573625572604px 377.58495258377343px',
							'2212.6836798136223px 378.08805768557363px',
							'2210.7261435993455px 378.49968913250103px',
							'2209.820554416105px 378.93876267589025px',
							'2209.820554416105px 378.93876267589025px',
							'2209.0430283496867px 379.3046572953813px',
							'2205.777418870729px 379.63396245292324px',
							'2201.6976938634043px 380.8597094282182px',
							'2200.398767964211px 381.31707770258197px',
							'2196.3373376878603px 382.6068562362879px',
							'2192.6235073000266px 384.0064031558411px',
							'2189.7329398060474px 384.5369503541031px',
							'2188.004087728952px 385.04920282139057px',
							'2186.1380251695477px 385.92734990816905px',
							'2184.281109975631px 386.41216027899463px',
							'2182.424194781714px 386.86952855335846px',
							'2179.0579642823964px 388.0952755286534px',
							'2177.26508064689px 388.53434907204263px',
							'2174.0817974573183px 388.9734226154319px',
							'2172.481008497045px 389.6960644889267px',
							'2171.584566679292px 390.1351380323159px',
							'2167.733525809149px 391.07731667750534px',
							'2166.9285576462685px 391.4798007589455px',
							'2165.0807898178386px 391.60786387576735px',
							'2161.732854049496px 392.02864268818206px',
							'2158.2385604333563px 392.48601096254583px',
							'2154.8265931066026px 393.7117579378408px',
							'2151.460362607285px 393.7117579378408px',
							'2148.2862267832px 393.9678841714845px',
							'2145.459690847632px 394.48013663877197px',
							'2141.4714394951798px 394.5716102936447px',
							'2137.8490827622186px 395.33084162908864px',
							'2134.3364944151044px 395.97115721319796px',
							'2130.842200798965px 396.6297675282818px',
							'2128.0705490563205px 396.6663569902309px',
							'2126.1496023039927px 397.5262093460348px',
							'2123.50601367817px 397.5445040770094px',
							'2120.917309245271px 398.42265116378786px',
							'2119.124425609765px 398.42265116378786px',
							'2116.800994775997px 398.42265116378786px',
							'2114.788574368796px 399.30079825056634px',
							'2113.1329012155993px 399.30079825056634px',
							'2109.5745760410487px 400.5265452258613px',
							'2107.754250309081px 400.5265452258613px',
							'2105.997956135524px 400.5265452258613px',
							'2104.141040941607px 400.5265452258613px',
							'2103.2080096619047px 400.96561876925057px',
							'2101.5340417777334px 401.4046923126398px',
							'2100.6375999599804px 401.4046923126398px',
							'2099.8875159900235px 401.4046923126398px',
							'2099.8875159900235px 401.4046923126398px',
							'2099.2289056749396px 401.4046923126398px',
							'2099.2289056749396px 401.4046923126398px',
							'2099.1282846545796px 401.4046923126398px',
							'2100.4363579192604px 401.4046923126398px',
							'2101.250473447628px 401.4046923126398px',
							'2102.046294245021px 401.4046923126398px',
							'2102.8055255804647px 401.4046923126398px',
							'2104.452051368174px 401.4046923126398px',
							'2105.266166896542px 401.4046923126398px',
							'2106.071135059422px 401.4046923126398px',
							'2106.693155912557px 401.4046923126398px',
							'2108.2482080453938px 401.4046923126398px',
							'2109.0074393808377px 401.4046923126398px',
							'2110.736291457933px 401.4046923126398px',
							'2111.5869964482495px 401.4046923126398px',
							'2112.4194067075914px 401.4046923126398px',
							'2113.224374870472px 401.4046923126398px',
							'2114.8800480236687px 401.4046923126398px',
							'2115.6941635520366px 401.4046923126398px',
							'2116.508279080404px 401.4046923126398px',
							'2118.063331213241px 401.4046923126398px',
							'2118.721941528325px 401.4046923126398px',
							'2119.4537307673068px 401.4046923126398px',
							'2120.203814737263px 401.4046923126398px',
							'2120.95389870722px 401.4046923126398px',
							'2121.713130042664px 401.4046923126398px',
							'2123.4145400232974px 401.4046923126398px',
							'2124.265245013614px 401.4046923126398px',
							'2125.994097090709px 401.4046923126398px',
							'2127.7686859952405px 401.4046923126398px',
							'2129.3603275900264px 401.4046923126398px',
							'2130.9245270883507px 401.4046923126398px',
							'2132.726558089344px 401.4046923126398px',
							'2135.205494136396px 401.4046923126398px',
							'2137.894819589655px 401.4046923126398px',
							'2140.5292608499904px 401.4046923126398px',
							'2143.200291572275px 401.4046923126398px',
							'2147.3714902344727px 401.4046923126398px',
							'2150.8474891196374px 401.4046923126398px',
							'2154.982098319886px 401.4046923126398px',
							'2159.0343812307497px 401.4046923126398px',
							'2160.708349114921px 401.4046923126398px',
							'2165.8034316913336px 401.4046923126398px',
							'2170.102693470353px 401.4046923126398px',
							'2172.2340296288885px 401.4046923126398px',
							'2179.378122074451px 401.4046923126398px',
							'2184.7567729809693px 401.4046923126398px',
							'2188.955413739629px 401.4046923126398px',
							'2193.940727930194px 401.4046923126398px',
							'2196.4013692462713px 401.4046923126398px',
							'2200.53597844652px 401.4046923126398px',
							'2204.158335179481px 401.4046923126398px',
							'2207.9087550292643px 401.4046923126398px',
							'2212.0525115950004px 401.4046923126398px',
							'2216.3609207395075px 401.4046923126398px',
							'2220.623593056578px 401.4046923126398px',
							'2224.9228548355977px 401.4046923126398px',
							'2228.453737913686px 401.4046923126398px',
							'2231.1522107324326px 401.4046923126398px',
							'2233.786651992768px 401.4046923126398px',
							'2236.347914329205px 401.4046923126398px',
							'2240.0708920825264px 401.4046923126398px',
							'2243.1535542517386px 401.4046923126398px',
							'2246.345984806798px 401.4046923126398px',
							'2249.3280259556495px 401.4046923126398px',
							'2251.358741093825px 401.4046923126398px',
							'2253.233951018716px 401.4046923126398px',
							'2255.081718847146px 401.4046923126398px',
							'2258.4570967119507px 401.4046923126398px',
							'2260.323159271355px 401.4046923126398px',
							'2262.8844216077923px 401.4046923126398px',
							'2266.15003108675px 401.4046923126398px',
							'2269.2967248143727px 401.4046923126398px',
							'2271.8396924198355px 401.4046923126398px',
							'2273.2666814358504px 401.4046923126398px',
							'2276.504848818346px 401.4046923126398px',
							'2279.779605662791px 401.4046923126398px',
							'2283.0726572382105px 401.81632375956724px',
							'2285.0301934524873px 402.273692033931px',
							'2286.8596665499426px 402.28283939941826px',
							'2288.6434028199615px 402.28283939941826px',
							'2290.417991724493px 402.72191294280753px',
							'2291.817538644046px 403.16098648619675px',
							'2293.573832817603px 403.16098648619675px',
							'2295.394158549571px 403.16098648619675px',
							'2296.318042463786px 403.16098648619675px',
							'2298.092631368317px 403.16098648619675px',
							'2298.8975995311976px 403.16098648619675px',
							'2300.6904831667034px 403.16098648619675px',
							'2303.4438401783736px 403.16098648619675px',
							'2304.349429361614px 403.16098648619675px',
							'2306.1240182661454px 404.03913357297523px',
							'2307.7522493228807px 404.03913357297523px',
							'2307.7522493228807px 404.03913357297523px',
							'2308.401712272477px 404.03913357297523px',
							'2308.401712272477px 404.03913357297523px',
							'2309.09691204951px 404.03913357297523px',
							'2309.09691204951px 404.03913357297523px',
							'2309.09691204951px 404.60627023318636px',
							'2303.919503183712px 427.72166281953247px',
							'2247.5077002236817px 509.9839206466044px',
							'2182.7717946702305px 579.7142877561083px',
							'2035.4992103250888px 716.2387176537007px',
							'1907.8660196811286px 827.059050532048px',
							'1823.5364572539322px 902.3876053197647px',
							'1723.2996262443633px 992.5806290243048px',
							'1686.0058171527396px 1034.5212997834647px',
							'1614.2172928085986px 1110.9475384296545px',
							'1538.55943286334px 1206.7478971778949px',
							'1507.8791690190164px 1241.0322230242048px',
							'1465.4994247164675px 1290.281638807698px',
							'1448.0736934632068px 1313.5433892418407px',
							'1427.382352730989px 1339.3755493779076px',
							'1410.3042213662447px 1361.265194988959px',
							'1396.8392993689747px 1379.212326074994px',
							'1389.887301598645px 1391.5155326553802px',
							'1382.258398782257px 1406.7367488262073px',
							'1377.2090530332807px 1419.0399554065932px',
							'1368.9032451708342px 1437.865233579407px',
							'1361.2743423544462px 1453.0864497502341px',
							'1354.3223445841165px 1465.38965633062px',
							'1343.7754321772875px 1481.9738299590513px',
							'1334.9207823856043px 1492.3743845180838px',
							'1328.645689661333px 1501.759581508029px',
							'1320.5685659360686px 1511.3734626351559px',
							'1315.6289885729395px 1515.059850926528px',
							'1312.262758073622px 1517.1728923540888px',
							'1310.469874438116px 1518.9474812586204px',
							'1307.1036439387983px 1521.060522686181px',
							'1305.3107603032925px 1522.8351115907126px',
							'1303.5178766677864px 1523.7224060429783px',
							'1301.7249930322803px 1524.6097004952442px',
							'1299.9321093967742px 1526.3842893997755px',
							'1299.035667579021px 1526.3842893997755px',
							'1297.3982891567987px 1527.1160786387577px',
							'1296.6573525523295px 1527.8478678777396px',
							'1295.91641594786px 1527.8478678777396px',
							'1295.1754793433906px 1528.5796571167218px',
							'1295.1754793433906px 1528.5796571167218px',
							'1294.4985742973322px 1528.5796571167218px',
						],
						{
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					),
				}}
			/>
		</AbsoluteFill>
	);
};
